module.exports = __webpack_public_path__ + "static/media/Ft_Macon_History_Museum_diorama_detail_in_studio_2_acrylic_on_canvas_2010.836e5376.webp";